import { RefObject, useEffect } from "react";
import "../App.css";

type AutoExpandingTextareaProps = {
  value: string;
  onChange: (value: string) => void;
  textareaRef: RefObject<HTMLTextAreaElement>;
  placeholder?: string;
  maxLength?: number;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
};

const MAX_ROWS = 4;

const AutoExpandingTextarea = ({
  value,
  onChange,
  textareaRef,
  placeholder = "",
  maxLength,
  onBlur,
  onKeyDown,
}: AutoExpandingTextareaProps) => {
  useEffect(() => {
    const tx = textareaRef.current;
    if (!tx) return;

    const computed = window.getComputedStyle(tx);
    const lineHeight = parseFloat(computed.lineHeight);

    const maxHeight = lineHeight * MAX_ROWS;

    tx.style.height = "auto";

    if (tx.scrollHeight > maxHeight) {
      tx.style.height = `${maxHeight}px`;
      tx.style.overflowY = "auto";
    } else {
      tx.style.height = `${tx.scrollHeight * 0.9}px`;
      tx.style.overflowY = "hidden";
    }
  }, [value, textareaRef]);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      onFocus={() =>
        textareaRef.current && (textareaRef.current.placeholder = "")
      }
      placeholder={placeholder}
      maxLength={maxLength}
      autoComplete="off"
      className="text-h3-no-uppercase bottom-margin-l"
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      rows={1}
      style={{ resize: "none" }}
    />
  );
};

export default AutoExpandingTextarea;
